import React from 'react';
import { Menu } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const Header = ({ setSidebarOpen }) => {
  const location = useLocation();
  
  const getPageTitle = () => {
    const path = location.pathname === '/' ? 'Dashboard' : location.pathname.substring(1);
    const title = path.replace(/[-/]/g, ' ');
    return title.charAt(0).toUpperCase() + title.slice(1);
  }

  return (
    <header className="md:hidden bg-white shadow-sm flex items-center justify-between p-4 sticky top-0 z-10">
      <button onClick={() => setSidebarOpen(true)} className="text-gray-600">
        <Menu size={24} />
      </button>
      <h1 className="text-lg font-semibold text-gray-800 capitalize">{getPageTitle()}</h1>
      <div className="w-6"></div> {/* Espaço para centralizar o título */}
    </header>
  );
};

export default Header;